import React, { useEffect, useState, useRef } from 'react';
import styles from './index.module.scss';
import EcoImg from 'eco-design/base/eco-img';
import EcoLink from 'eco-design/base/eco-link';
import { Navigation, Pagination } from 'swiper';
import { Swiper, SwiperSlide } from 'swiper/react';
import { LeftIcon, RightIcon } from '../icons';
import { getProductFromGeneralKey } from '@/utils/productGetServerSideProps';
import { useGlobal } from '@/utils/useGlobal';
import { generalKey, productPageTheme, generalKeys } from '../../../../config/pageConfig';
import { productDetailData, ResponseObj } from '@/service';
import { useRouter } from 'next/router';
import { getMemberListProducts } from '@/service/vip';
import { productSeriesConf } from './productData';
import { useProductDispatch } from '../../../../ProductProvider';
import { saveCookieForShopify } from '@elem/ui-common/utils/CookieForShopify';
import gtm from '@/utils/gtm';

interface ComparisonItemIprops {
    className: string;
    value: string | number;
    pc?: string;
    h5?: string;
    label?: string;
    id: string | number;
    inventoryQuantity?: number;
    variantId?: string;
}

export interface GeneralKeyItemProps {
    key: string;
    url: string;
}

const ProductComparison = () => {
    const [slidesOffset, setSlidesOffset] = useState<any>(undefined);
    const [spaceBetween, setSpaceBetween] = useState<number>(32);
    const [isBeginning, setIsBeginning] = useState(true);
    const [isEnd, setIsEnd] = useState(false);
    const swiperRef = useRef<any>(null);
    const { gloproductlist } = useGlobal();
    const { locale } = useRouter();
    const [productData, setProductData] = useState<any>([]);
    const [hasTracked, setHasTracked] = useState(false);
    const [timer, setTimer] = useState<NodeJS.Timeout | null>(null);
    const dispatch = useProductDispatch();
    const getVids = () => productSeriesConf[locale as string]?.map((item) => item.variantId);

    // const productMsg = getProductFromGeneralKey({ gloproductlist, generalKey });
    // const [productDataA, setProductDataA] = useState<any>({});
    const [productPageData, setProductPageData] = useState<any>({
        productCatagory: null,
        productSeries: [],
        supportDataArr: [],
    });
    // ['53215190188342', '53215190188342', '53215190221110']
    const contentList: ComparisonItemIprops[][] = [
        [
            {
                className: 'img',
                pc: 'https://websiteoss.ecoflow.com/upload/image/1763091787064/sl_d3s.png',
                id: 'prod_img',
                value: '',
            },
            {
                className: 'label',
                value: 'Home Essentials Power',
                id: 'label',
            },
            {
                className: 'prod-title',
                value: 'EcoFlow DELTA 3 1000 Air',
                label: 'Essential, Compact, Affordable Backup',
                id: 'prod-title',
            },
            {
                className: 'prod-buy-btn',
                id: 'prod-buy',
                value: 9999999,
                inventoryQuantity: 0,
                variantId: '53215190188342',
            },
            {
                className: 'line',
                id: 'line',
                value: '',
            },
            {
                className: 'text',
                value: '',
                label: 'Rated Capacity',
                id: '1968921445590065153',
            },
            {
                className: 'text',
                value: '',
                label: 'AC Discharging Power',
                id: '2001572063270588417',
            },
            {
                className: 'text',
                value: '',
                label: 'Net Weight',
                id: '1968921151061204993',
            },
            {
                className: 'text',
                value: '',
                label: 'Dimensions (HWD)',
                id: '1968921303050199041',
            },
            {
                className: 'text',
                value: '',
                label: 'UPS',
                id: '2001576345738956802',
            },
            {
                className: 'text',
                value: '',
                label: 'AC Charging',
                id: '1983802414880288769',
            },
            {
                className: 'text',
                value: '',
                label: 'Solar Charging',
                id: '1983802312883204098',
            },
            {
                className: 'text',
                value: '',
                label: 'USB-A',
                id: '1991431116902055938',
            },
            {
                className: 'text',
                value: '',
                label: 'USB-C',
                id: '1991431183042035713',
            },
            {
                className: 'text',
                value: '',
                label: 'Cell Chemistry',
                id: '1968921519007162370',
            },
            {
                className: 'text',
                value: '',
                label: 'Warrenty',
                id: '1983785243965943809',
            },
            {
                className: 'text',
                value: '',
                label: 'App Remote Control',
                id: '1991430398104539137',
            },
        ],
        [
            {
                className: 'img',
                pc: 'https://websiteoss.ecoflow.com/upload/image/1763091787064/sl_d3s.png',
                id: 'prod_img',
                value: '',
            },
            {
                className: 'label',
                value: 'Work-From-Home Power',
                id: 'label',
            },
            {
                className: 'prod-title',
                value: 'EcoFlow DELTA 3 1000 Air (10ms UPS)',
                label: 'Work-from-Home, UPS, Continuous Power',
                id: 'prod-title',
            },
            {
                className: 'prod-buy-btn',
                id: 'prod-buy',
                value: 38990,
                inventoryQuantity: 0,
                variantId: '53215190188342',
            },
            {
                className: 'line',
                id: 'line',
                value: '',
            },
            {
                className: 'text',
                value: '',
                label: 'Rated Capacity',
                id: '1968921445590065153',
            },
            {
                className: 'text',
                value: '',
                label: 'AC Discharging Power',
                id: '2001572063270588417',
            },
            {
                className: 'text',
                value: '',
                label: 'Net Weight',
                id: '1968921151061204993',
            },
            {
                className: 'text',
                value: '',
                label: 'Dimensions (HWD)',
                id: '1968921303050199041',
            },
            {
                className: 'text',
                value: '',
                label: 'UPS',
                id: '2001576345738956802',
            },
            {
                className: 'text',
                value: '',
                label: 'AC Charging',
                id: '1983802414880288769',
            },
            {
                className: 'text',
                value: '',
                label: 'Solar Charging',
                id: '1983802312883204098',
            },
            {
                className: 'text',
                value: '',
                label: 'USB-A',
                id: '1991431116902055938',
            },
            {
                className: 'text',
                value: '',
                label: 'USB-C',
                id: '1991431183042035713',
            },
            {
                className: 'text',
                value: '',
                label: 'Cell Chemistry',
                id: '1968921519007162370',
            },
            {
                className: 'text',
                value: '',
                label: 'Warrenty',
                id: '1983785243965943809',
            },
            {
                className: 'text',
                value: '',
                label: 'App Remote Control',
                id: '1991430398104539137',
            },
        ],
        [
            {
                className: 'img',
                pc: 'https://websiteoss.ecoflow.com/upload/image/1764050035279/sl_ds.png',
                id: 'prod_img',
                value: '',
            },
            {
                className: 'label',
                value: 'High-Capacity Power Station',
                id: 'label',
            },
            {
                className: 'prod-title',
                value: 'EcoFlow DELTA 3 2000 Air',
                label: 'Advanced, High-Power, Premium Backup',
                id: 'prod-title',
            },
            {
                className: 'prod-buy-btn',
                id: 'prod-buy',
                value: 69990,
                inventoryQuantity: 0,
                variantId: '53215190221110',
            },
            {
                className: 'line',
                id: 'line',
                value: '',
            },
            {
                className: 'text',
                value: '',
                label: 'Rated Capacity',
                id: '1968921445590065153',
            },
            {
                className: 'text',
                value: '',
                label: 'AC Discharging Power',
                id: '2001572063270588417',
            },
            {
                className: 'text',
                value: '',
                label: 'Net Weight',
                id: '1968921151061204993',
            },
            {
                className: 'text',
                value: '',
                label: 'Dimensions (HWD)',
                id: '1968921303050199041',
            },
            {
                className: 'text',
                value: '',
                label: 'UPS',
                id: '2001576345738956802',
            },
            {
                className: 'text',
                value: '',
                label: 'AC Charging',
                id: '1983802414880288769',
            },
            {
                className: 'text',
                value: '',
                label: 'Solar Charging',
                id: '1983802312883204098',
            },
            {
                className: 'text',
                value: '',
                label: 'USB-A',
                id: '1991431116902055938',
            },
            {
                className: 'text',
                value: '',
                label: 'USB-C',
                id: '1991431183042035713',
            },
            {
                className: 'text',
                value: '',
                label: 'Cell Chemistry',
                id: '1968921519007162370',
            },
            {
                className: 'text',
                value: '',
                label: 'Warrenty',
                id: '1983785243965943809',
            },
            {
                className: 'text',
                value: '',
                label: 'App Remote Control',
                id: '1991430398104539137',
            },
        ],
    ];

    const formatCmsParamsProductData = (data: any) => {
        try {
            // 因为中间那个需要写死，然后又不取配置，那就分开遍历完事
            // 后面又配置多一个，已经不想改了
            if (data?.length !== 2) {
                return contentList;
            }
            const productImages1 = data[0].images ? JSON.parse(data[0].images) : {};
            const productImages2 = data[1].images ? JSON.parse(data[1].images) : {};
            const prodImg1 = productImages1?.transparentImages || productImages1?.spaceImages || productImages1?.images;
            const prodImg2 = productImages2?.transparentImages || productImages2?.spaceImages || productImages2?.images;

            const prod1Sku = data[0].skuList[0];
            const prod3Sku = data[0].skuList[1];
            const prod2Sku = data[1].skuList[0];
            const title1 = prod1Sku.name;
            const title3 = prod3Sku.name;
            const title2 = prod2Sku.name;
            const pro1Spec = prod1Sku.ownSpec ? JSON.parse(prod1Sku.ownSpec) : {};
            const pro3Spec = prod3Sku.ownSpec ? JSON.parse(prod3Sku.ownSpec) : {};
            const pro2Spec = prod2Sku.ownSpec ? JSON.parse(prod2Sku.ownSpec) : {};
            let pro1Specs: any = {};
            let pro3Specs: any = {};
            let pro2Specs: any = {};

            Object.entries(pro1Spec).forEach(([k, v]: any) => {
                pro1Specs = {
                    ...pro1Specs,
                    ...v,
                };
            });
            Object.entries(pro3Spec).forEach(([k, v]: any) => {
                pro3Specs = {
                    ...pro3Specs,
                    ...v,
                };
            });
            Object.entries(pro2Spec).forEach(([k, v]: any) => {
                pro2Specs = {
                    ...pro2Specs,
                    ...v,
                };
            });

            contentList[0].forEach((item: any) => {
                if (pro1Specs[item.id]) {
                    item.value = formatText(pro1Specs[item.id]);
                }
                if (item.id === 'prod_img') item.pc = prodImg1;
                if (item.id === 'prod-title') item.value = title1;
            });
            contentList[1].forEach((item: any) => {
                if (pro3Specs[item.id]) {
                    item.value = formatText(pro3Specs[item.id]);
                }
                if (item.id === 'prod_img') item.pc = prodImg1;
                if (item.id === 'prod-title') item.value = title3;
            });
            contentList[2].forEach((item: any) => {
                if (pro2Specs[item.id]) {
                    item.value = formatText(pro2Specs[item.id]);
                }
                if (item.id === 'prod_img') item.pc = prodImg2;
                if (item.id === 'prod-title') item.value = title2;
            });
            // 中间那个数据写死，直接获取 第一个的值，呜呜呜呜
            // contentList[1].splice(5);
            // const cpData = JSON.parse(JSON.stringify(contentList[0].slice(5)));
            // contentList[1] = contentList[1].concat(cpData);
            // contentList[1][9].value = `<10ms`;
            return contentList;
        } catch (error) {
            return contentList;
        }
    };

    const getProductSeriesData = async () => {
        const promiseAll = new Set();
        const proMsgAll: any[] = [];
        const productPageData = {
            productCatagory: null,
            productSeries: [] as any[],
            supportDataArr: [] as any[],
        };
        generalKeys?.map((item: GeneralKeyItemProps, _: number) => {
            const productMsg = getProductFromGeneralKey({ gloproductlist, generalKey: item.key });
            if (Object.keys(productMsg)?.length > 0) {
                proMsgAll.push(productMsg);
                promiseAll.add(productDetailData({ handle: item.url }, locale || 'us'));
            }
        });

        Promise.all(promiseAll).then((resArr) => {
            resArr.map((resItem: any, resIndex) => {
                if (resItem && resItem.code === '0') {
                    if (resIndex === 0) {
                        productPageData.productCatagory = resItem?.data?.productCatagoryResponseList;
                    }
                    productPageData.productSeries.push(resItem?.data?.spuResponse);
                }
            });
            setProductPageData(productPageData);
            dispatch({
                type: 'changeProductSpecData',
                payload: productPageData,
            });
            const formatData = formatCmsParamsProductData(productPageData?.productSeries);

            setProductData([...formatData]);
        });
    };

    const formatText = (str: string) => {
        if (str.indexOf('/') > -1) {
            return str.replaceAll('/', ` `);
        }
        return str;
    };

    const getProductData = () => {
        if (!getVids()) return;

        try {
            getMemberListProducts(
                {
                    variantIds: getVids(),
                },
                locale as string,
            ).then((res) => {
                if (res?.code === '0' && res.data) {
                    res.data.forEach((item: any) => {
                        if (contentList[0][3].variantId === item.variantId) {
                            contentList[0][3].value = item.price;
                            contentList[0][3].inventoryQuantity = item.inventoryQuantity;
                        }
                        if (contentList[2][3].variantId === item.variantId) {
                            // contentList[2][3].value = item.price;
                            contentList[2][3].inventoryQuantity = item.inventoryQuantity;
                        }
                    });
                }
                setProductData([...contentList]);
            });
        } catch (error) {
            console.log('error->>', error);
        }
    };

    const handlePushGtm = (url: string) => {
        saveCookieForShopify(url, locale as string);
    };

    useEffect(() => {
        if (typeof window !== 'undefined') {
            if (window.innerWidth < 768) {
                setSlidesOffset(24);
                setSpaceBetween(16);
            } else {
                setSlidesOffset(undefined);
                setSpaceBetween(32);
            }
            getProductSeriesData();
            getProductData();

            const productElem = document.getElementById('D3A-ProductComparison');
            const observer = new IntersectionObserver(
                ([entry]) => {
                    if (entry.isIntersecting && !hasTracked) {
                        const timeout = setTimeout(() => {
                            gtm.push({
                                event: 'uaEvent',
                                event_name: 'view_list',
                                product_name: 'DELTA 3 Air Series',
                                position: 1,
                                list_type: 'Product Comparison',
                                list_title: 'Explore the DELTA 3 Air Series',
                            });

                            setHasTracked(true); // 避免重复埋点
                        }, 5000);
                        setTimer(timeout);
                    } else {
                        // 如果离开视口前未满 5s，则清除定时器
                        if (timer) {
                            clearTimeout(timer);
                            setTimer(null);
                        }
                    }
                },
                {
                    threshold: 0.5, // 超过一半面积进入视口才触发
                },
            );

            const target = productElem;
            if (target) {
                observer.observe(target);
            }

            return () => {
                if (target) {
                    observer.unobserve(target);
                }
                if (timer) {
                    clearTimeout(timer);
                }
            };
        }
    }, []);

    const renderItemRow = (item: ComparisonItemIprops, i: number, contentIndex: number) => {
        let prodTitle = '';
        if (item.className === 'img') {
            return (
                <div className={item.className} key={i}>
                    <EcoImg pc={item.pc} />
                </div>
            );
        }
        if (item.className === 'label') {
            return (
                <div className={item.className} key={i}>
                    <span>{item.value}</span>
                </div>
            );
        }
        if (item.className === 'line') {
            <div className={item.className} key={i}>
                <span></span>
            </div>;
        }
        if (item.className === 'prod-title') {
            prodTitle = item.value as string;
            return (
                <div className={item.className} key={i}>
                    <span className="value-1">{item.value}</span>
                    <span className="label-1">{item.label}</span>
                </div>
            );
        }
        if (item.className === 'prod-buy-btn') {
            return (
                <div className={item.className} key={i}>
                    <span className="price">{`₱${item.value}`}</span>
                    <EcoLink
                        className={`buy-btn __btn_d3a_${contentIndex} ${contentIndex === 1 || item.inventoryQuantity === 0 ? 'disabled-link' : ''}`}
                        onClick={() => handlePushGtm(`https://${locale}.ecoflow.com/cart/${item.variantId}:1?channel=buy_button`)}
                        dataLayer={{
                            event: 'uaEvent',
                            event_name: 'buy',
                            product_name: prodTitle,
                            position: 'Explore the DELTA 3 Air Series',
                            __btn_id1: `__btn_d3a_${contentIndex}`,
                            __btn_type: 'href',
                            __btn_id2: `https://${locale}.ecoflow.com/cart/${item.variantId}:1?channel=buy_button`,
                        }}
                        href={`https://${locale}.ecoflow.com/cart/${item.variantId}:1?channel=buy_button`}
                    >
                        {contentIndex === 1 ? 'Sold Out' : item.inventoryQuantity === 0 ? 'Coming Soon' : 'Buy Now'}
                    </EcoLink>
                </div>
            );
        }
        return (
            <div className={item.className} key={i}>
                <span className="value-2">{item.value}</span>
                <span className="label-2">{item.label}</span>
            </div>
        );
    };

    return (
        <section className={`${styles.ProductComparison} GtmModuleData-section`} id="D3A-ProductComparison" data-section-id={'D3A-ProductComparison'}>
            <div className="comparison-content">
                <div className="title">Explore the DELTA 3 Air Series</div>
                <Swiper
                    modules={[Navigation]}
                    className="comparison"
                    slidesPerView={'auto'}
                    onSwiper={(swiper) => {
                        swiperRef.current = swiper;
                    }}
                    spaceBetween={spaceBetween}
                    slidesOffsetBefore={slidesOffset}
                    slidesOffsetAfter={slidesOffset}
                    onSlideChange={(swiper) => {
                        setIsBeginning(swiper.isBeginning);
                        setIsEnd(swiper.isEnd);
                    }}
                    onReachEnd={() => setIsEnd(true)}
                    onFromEdge={() => setIsEnd(false)}
                >
                    {productData.map((item, index: number) => (
                        <SwiperSlide key={index} className="item-swiper-slide">
                            <div className="item-comparison">{item.map((v: ComparisonItemIprops, i: number) => renderItemRow(v, i, index))}</div>
                        </SwiperSlide>
                    ))}
                </Swiper>
                <div className="swiper-btn-box">
                    <span className={`btn-item ${isBeginning ? 'disabled' : ''}`} onClick={() => swiperRef.current?.slidePrev()}>
                        <LeftIcon />
                    </span>
                    <span className={`btn-item ${isEnd ? 'disabled' : ''}`} onClick={() => swiperRef.current?.slideNext()}>
                        <RightIcon />
                    </span>
                </div>
            </div>
        </section>
    );
};

export default ProductComparison;
